import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useRoute } from 'react-router5';

import { Button } from '$uikit';
import { useTranslator } from '$hooks';
import { authSelector } from '$store/auth';
import { AuthRequired } from '$core/AuthRequired/AuthRequired';
import { CHAT } from '$shared/constants/pages';
import { PaymentFailed } from '$shared/components';
import { statReachGoal } from '$utils';

export const BuyMessageFailed: FC = () => {
  const { isLogged } = useSelector(authSelector);
  const t = useTranslator();

  const {
    route: { params },
  } = useRoute();
  const peerId = +params.peerId;

  useEffect(() => {
    statReachGoal('payment_failed');
    statReachGoal('buy_message_failed');
  }, []);

  if (!isLogged) {
    return <AuthRequired />;
  }

  return (
    <>
      <PaymentFailed>
        <Link routeName={CHAT} routeParams={{ peerId }}>
          <Button size="small">{t('buy_message_failed_go_to_chat_button')}</Button>
        </Link>
      </PaymentFailed>
    </>
  );
};
